import React from "react"
import styles from "./styles.css"
import iconMinus from "../../../../../assets/svg/fixed-voice-minus.svg"
import iconPlus from "../../../../../assets/svg/fixed-voice-plus.svg"
import PropTypes from "prop-types"

const AmountNumbers = ({ formik, limit }) => {
  const {
    values,
    touched,
    errors,
    setFieldValue,
    setFieldTouched,
    handleBlur
  } = formik

  const isErrorAmount = touched.qnt && errors.qnt

  const onControlNumber = (control) => {
    const currentAmount = values.qnt
    let updatedAmount

    switch (control) {
      case "minus":
        updatedAmount = parseInt(currentAmount, 10) - 1
        break
      case "plus":
        updatedAmount = parseInt(currentAmount, 10) + 1
        break
      default:
        updatedAmount = parseInt(currentAmount, 10)
        break
    }

    if (updatedAmount > limit || updatedAmount < 1) {
      return
    }

    setFieldValue("qnt", updatedAmount, true)
    setFieldTouched("qnt", true)
  }

  const handleChange = (event) => {
    const { name, value } = event.target

    setFieldValue(name, value, true)

    const updatedErrors = { ...errors }
    if (updatedErrors[name]) {
      delete updatedErrors[name]
      formik.setErrors(updatedErrors)
    }
  }

  const preventRerender = (e) => {
    e.key === "Enter" && e.preventDefault()
  }

  return (
    <div>
      <div className={styles.line}>
        <img src={iconMinus}
             alt={"icon minus"}
             onClick={() => onControlNumber("minus")}
        />
        <input
          className={`${styles.amount_numbers} ${
            isErrorAmount && styles.focus_error
          }`}
          id="qnt"
          name="qnt"
          type="number"
          onChange={(e) => handleChange(e)}
          onKeyDown={(e) => preventRerender(e)}
          value={formik.values.qnt}
          onBlur={handleBlur}
          tabIndex={8}
        />
        <img src={iconPlus}
             alt={"icon plus"}
             onClick={() => onControlNumber("plus")}
        />
      </div>
      <div>
        <div className={styles.free_number}>
          {limit} números livres.
          {isErrorAmount && <div className={styles.error}>{errors.qnt}</div>}
        </div>
      </div>
    </div>
  )
}

AmountNumbers.propTypes = {
  formik: PropTypes.object.isRequired,
  limit: PropTypes.number.isRequired
}

export default AmountNumbers



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/NewSale/components/AmountNumbers.js